import { makeStyles} from "@material-ui/core";

const drawerWidth = 244;
const useStyles = makeStyles((theme) => ({
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
  },
  // toolbar: {
  //   display: "flex",
  //   alignItems: "center",
  //   justifyContent: "flex-end",
  //   padding: theme.spacing(0, 1),
  //   ...theme.mixins.toolbar,
  // },
  drawerHeader:{
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
  },
  logo: {
    flexGrow: 1,
    padding: theme.spacing(0, 1),
    marginLeft: theme.spacing(6),
    color:"white"
  },
  subList: {
    width: "100%",
    maxWidth: 360,
    // height: 1000,
    maxHeight: 1400,
    // display:"flex-block",
  },
  icon: {
    color: "#198754",
  },
  profile: {
    fontSize: 38,
  },
  // content: {
  //   flexGrow: 1,
  //   padding: theme.spacing(3),
  //   // backgroundColor:"#F4F5F9",
  //   height:"90vh"
  //   },
  root: {
    display: "flex"
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0
    }
  },
  appBar: {
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth
    }
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none"
    }
  },
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3)
  },
  contentAll: {
    [theme.breakpoints.up("sm")]: {
      // marginLeft: drawerWidth,
      // width: `calc(100% - ${drawerWidth}px)`
      width: `10px`

    }
  },
}));

export default useStyles;
